import { PlayCircleIcon, PauseCircleIcon } from '@heroicons/react/24/solid';
import { useEffect, useRef, useState } from 'react';

const MUX_ENV_KEY = 'jue9kicinbhtv6qg94hb4c1mc';

export const MuxVideo = ({ playbackId, caption }) => {
  const ref = useRef(null);
  const [playbackState, setPlaybackState] = useState('paused');

  useEffect(() => {
    const handler = (event) => {
      switch (event.type) {
        case 'play':
        case 'playing':
          setPlaybackState('playing');
          break;
        case 'pause':
        case 'ended':
        case 'error':
          setPlaybackState('paused');
          break;
      }
    };

    const element = ref.current;
    if (ref) {
      element.addEventListener('ended', handler);
      element.addEventListener('error', handler);
      element.addEventListener('pause', handler);
      element.addEventListener('play', handler);
      element.addEventListener('playing', handler);
      return () => {
        element.removeEventListener('ended', handler);
        element.removeEventListener('error', handler);
        element.removeEventListener('pause', handler);
        element.removeEventListener('play', handler);
        element.removeEventListener('playing', handler);
      };
    }
  }, []);

  return (
    <figure>
      <div
        className="relative group rounded-lg overflow-hidden w-full aspect-video bg-gray-100"
        data-playback-state={playbackState}
      >
        <mux-video
          ref={ref}
          playback-id={playbackId}
          env-key={MUX_ENV_KEY}
          disable-tracking
          disable-cookies
          disablePictureInPicture
          onClick={() => {
            if (ref.current.paused || ref.current.ended) {
              ref.current.play();
            } else {
              ref.current.pause();
            }
          }}
        />
        <PlayCircleIcon className="absolute pointer-events-none top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square h-1/5 text-white group-hover:scale-110 transition-transform hidden group-data-[playback-state=paused]:block" />
        <PauseCircleIcon className="absolute pointer-events-none top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square h-1/5 text-white opacity-0 group-hover:opacity-100 transition-opacity hidden group-data-[playback-state=playing]:block" />
      </div>
      <figcaption className="caption italic">{caption}</figcaption>
    </figure>
  );
};
